import * as types from '../actions/actionTypes';
import { assign } from 'lodash';

const host = window.location.hostname
const local = (host.indexOf("local") > -1);
const staging = host.indexOf('staging') > -1;
const develop = (host.indexOf('develop.') > -1)
const ROOT_URL = (local || develop)
  ? 'https://myphoto-api-develop.appspot.com'
  : (staging)
    ? 'https://myphoto-api-staging.appspot.com'
    : 'https://mp-cloud-api.appspot.com'

const initialState = {
  results: [
    {
      emailHtml: '',
      imageData: {},
      durationBreakdown: {},
    },
  ],
  log: {
    emailHtml: '',
    imageData: {},
    durationBreakdown: {},
  },
  meta: {
    count: 0,
    totalCount: 0,
    pageCount: 0,
    self: `${ROOT_URL}/logging`,
    previous: null,
    next: null,
    first: null,
    last: null,
    page: 1,
    limit: 20,
  },
};

function log(state = initialState, action) {
  switch (action.type) {
    case types.LOGS_FETCH_SUCCESS:
      return assign({}, state, action.res);
    case types.LOGS_FETCH_ERROR:
    case types.LOG_FETCH_ERROR:
      return assign({}, state, {
        error: action.res,
      });
    case types.LOG_FETCH_SUCCESS:
      return assign({}, state, {
        log: action.res,
      });
    case types.LOGS_CLEAR_ERRORS:
      return assign({}, state, {
        error: false,
      });
    default:
      return state;
  }
}

export default log;



// WEBPACK FOOTER //
// ./src/reducers/logs.js